module.exports = __webpack_public_path__ + "img/logo-sfc.6c35b6fb.png";